import React from 'react';
import { Helmet } from 'react-helmet-async';
import { ScrollText } from 'lucide-react';

function Terms() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Helmet>
        <title>Terms of Service | Easy Unit Converter</title>
        <meta name="description" content="Terms and conditions for using Easy Unit Converter." />
      </Helmet>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="mb-8 flex items-center gap-3">
          <ScrollText className="w-8 h-8 text-blue-600" />
          <h1 className="text-4xl font-bold text-gray-900">Terms of Service</h1>
        </div>

        <div className="prose prose-lg max-w-none">
          <p className="lead">
            By using Easy Unit Converter, you agree to these terms. Please read them carefully.
          </p>

          <h2>Acceptance of Terms</h2>
          <p>
            By accessing or using our service, you agree to be bound by these Terms of Service
            and our Privacy Policy.
          </p>

          <h2>Use License</h2>
          <p>
            We grant you a personal, non-exclusive, non-transferable license to use our service
            for personal or business purposes.
          </p>

          <h2>Accuracy</h2>
          <p>
            While we strive for accuracy in all conversions, you are responsible for verifying
            critical calculations. We make no guarantees about the accuracy of results.
          </p>

          <h2>Prohibited Uses</h2>
          <p>
            You may not:
          </p>
          <ul>
            <li>Use the service for any unlawful purpose</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Interfere with other users' access to the service</li>
            <li>Modify, adapt, or hack the service</li>
          </ul>

          <h2>Intellectual Property</h2>
          <p>
            The service and its original content, features, and functionality are owned by
            Easy Unit Converter and are protected by international copyright, trademark, and
            other intellectual property laws.
          </p>

          <h2>Disclaimer</h2>
          <p>
            The service is provided "as is" without warranties of any kind. We are not
            responsible for any errors or omissions in conversion results.
          </p>

          <h2>Limitation of Liability</h2>
          <p>
            We shall not be liable for any indirect, incidental, special, consequential,
            or punitive damages resulting from your use of the service.
          </p>

          <h2>Changes to Terms</h2>
          <p>
            We reserve the right to modify these terms at any time. We will notify users
            of any changes by updating the date at the top of this page.
          </p>

          <h2>Contact</h2>
          <p>
            Questions about these terms should be sent to{' '}
            <a href="mailto:aristomenis.georgiopoulos@gmail.com">aristomenis.georgiopoulos@gmail.com</a>
          </p>
        </div>
      </main>
    </div>
  );
}

export default Terms;